import { combineReducers } from 'redux';
import { resource } from '@adobe/edex/ui/store/reducers/forms/resource';
import { comment } from '@adobe/edex/ui/store/reducers/forms/comment';

export const forms = combineReducers({
  resource,
  comment,
});
